/* The Grand Guild — shared front-end behaviour.
   Exposes window.GG with: dialog, cart, money, deliveryDate, contact, ref. */
(function () {
  'use strict';
  var GG = window.GG = window.GG || {};
  var cfg = window.GGConfig || {};

  /* ---------- Money ---------- */
  GG.money = function (cents, opts) {
    var v = (cents || 0) / 100;
    var whole = Math.round(v) === v;
    return '£' + v.toLocaleString('en-GB', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  };

  /* ---------- Working-day delivery dates ---------- */
  GG.addWorkingDays = function (days, from) {
    var d = from ? new Date(from) : new Date();
    var n = parseInt(days, 10) || 0;
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  };
  GG.deliveryDate = function (days) {
    return GG.addWorkingDays(days).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  };
  GG.fillDates = function (root) {
    (root || document).querySelectorAll('[data-gg-turnaround]').forEach(function (el) {
      el.textContent = GG.deliveryDate(el.getAttribute('data-gg-turnaround'));
    });
  };

  /* ---------- Reveal on scroll ---------- */
  GG.reveal = function (root) {
    var els = (root || document).querySelectorAll('.gg-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (e) { e.classList.add('is-in'); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  };

  /* ---------- Dialogs: focus trap, Escape, return focus ---------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';
  var stack = [];
  GG.dialog = {
    open: function (el, trigger) {
      if (typeof el === 'string') el = document.getElementById(el);
      if (!el) return;
      el._ggTrigger = trigger || document.activeElement;
      el.classList.add('is-open'); el.removeAttribute('hidden'); el.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('gg-lock');
      stack.push(el);
      var target = el.querySelector('[autofocus]') || el.querySelector('[role=dialog]') || el;
      if (!target.hasAttribute('tabindex') && target.matches('[role=dialog]')) target.setAttribute('tabindex', '-1');
      setTimeout(function () { target.focus(); }, 30);
      el.dispatchEvent(new CustomEvent('gg:dialog:open', { bubbles: true }));
    },
    close: function (el) {
      if (typeof el === 'string') el = document.getElementById(el);
      el = el || stack[stack.length - 1];
      if (!el) return;
      el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
      stack = stack.filter(function (x) { return x !== el; });
      if (!stack.length) document.documentElement.classList.remove('gg-lock');
      if (el._ggTrigger && el._ggTrigger.focus) el._ggTrigger.focus();
      el.dispatchEvent(new CustomEvent('gg:dialog:close', { bubbles: true }));
    }
  };
  document.addEventListener('keydown', function (e) {
    var top = stack[stack.length - 1];
    if (!top) return;
    if (e.key === 'Escape') { e.preventDefault(); GG.dialog.close(top); return; }
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(top.querySelectorAll(FOCUSABLE), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-gg-open]');
    if (o) { e.preventDefault(); GG.dialog.open(o.getAttribute('data-gg-open'), o); return; }
    var c = e.target.closest('[data-gg-close]');
    if (c) { e.preventDefault(); GG.dialog.close(c.closest('.gg-overlay')); }
  });

  /* ---------- Disclosures (aria-expanded toggles) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gg-toggle]');
    if (!t) return;
    var target = document.getElementById(t.getAttribute('data-gg-toggle'));
    if (!target) return;
    var open = t.getAttribute('aria-expanded') !== 'true';
    t.setAttribute('aria-expanded', String(open));
    target.hidden = !open;
    var lo = t.getAttribute('data-label-open'), lc = t.getAttribute('data-label-closed');
    if (lo && lc) { var s = t.querySelector('[data-gg-toggle-label]') || t; s.textContent = open ? lo : lc; }
  });

  /* ---------- Cookies ---------- */
  GG.setCookie = function (k, v, days) {
    var d = new Date(); d.setTime(d.getTime() + days * 864e5);
    document.cookie = k + '=' + encodeURIComponent(v) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  };
  GG.getCookie = function (k) {
    var m = document.cookie.match('(?:^|; )' + k.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  };

  /* ---------- Affiliate ref capture: ?ref= -> 90-day first-party cookie -> cart attribute ---------- */
  GG.ref = (function () {
    try {
      var p = new URLSearchParams(location.search).get('ref');
      if (p && /^[A-Za-z0-9_-]{1,64}$/.test(p)) GG.setCookie('gg_ref', p, cfg.refDays || 90);
    } catch (e) {}
    try {
      var r = new URLSearchParams(location.search).get('refer');
      if (r && /^[A-Za-z0-9_.-]{1,64}$/.test(r)) GG.setCookie('gg_refer', r, cfg.refDays || 90);
    } catch (e) {}
    return GG.getCookie('gg_ref');
  })();
  GG.referrer = GG.getCookie('gg_refer');

  /* ---------- Cart API ---------- */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function json(url, body) {
    return fetch(root + url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  /* ---------- Bundle / multi-item pricing ----------
     Qualifying lines are swapped to their hidden "-saving" twin, which carries the discounted price, so the
     Downpay deposit at checkout is 50% of the discounted total. Package bundle: 2+ distinct packages or Passes,
     applied to one-off package lines only. Design Shop: 3+ items. Lines swap back when the cart stops qualifying. */
  var swapping = false;
  function swapMaps() {
    var S = window.GGSwap || {}, rev = {};
    Object.keys(S).forEach(function (b) { if (S[b] && S[b].length) rev[String(S[b][0])] = b; });
    return { S: S, rev: rev };
  }
  function isGiftLine(it) {
    var g = (window.GGConfig || {}).giftVariantId;
    return (g && Number(it.variant_id) === Number(g)) || !!(it.properties && it.properties._gg_gift);
  }
  function swapOps(cart) {
    var m = swapMaps(), pk = window.GGSwapPkgs || [], pkgs = {}, multi = 0, ops = [];
    if (!cart || !cart.items) return ops;
    cart.items.forEach(function (it) {
      if (isGiftLine(it)) return;
      var h = String(it.handle || '').replace(/-saving$/, '');
      if (pk.indexOf(h) > -1) pkgs[h] = true;
      var e = m.S[m.rev[String(it.variant_id)] || String(it.variant_id)];
      if (e && e[2] === 'design-shop') multi += it.quantity;
    });
    var want = { 'packages': Object.keys(pkgs).length >= 2, 'design-shop': multi >= 3 };
    cart.items.forEach(function (it) {
      if (isGiftLine(it)) return;
      var vid = String(it.variant_id), isSav = !!m.rev[vid], base = isSav ? m.rev[vid] : vid, e = m.S[base];
      if (!e) return;
      if (want[e[2]] && !isSav) ops.push({ line: it, to: Number(e[0]) });
      else if (!want[e[2]] && isSav) ops.push({ line: it, to: Number(base) });
    });
    return ops;
  }
  function applySwap(ops) {
    var plans = window.GGPlans || {}, updates = {};
    var items = ops.map(function (o) {
      var i = { id: o.to, quantity: o.line.quantity, properties: o.line.properties || {} };
      if (plans[String(o.to)]) i.selling_plan = plans[String(o.to)];
      updates[o.line.key] = 0;
      return i;
    });
    return json('cart/add.js', { items: items }).then(function () { return json('cart/update.js', { updates: updates }); });
  }
  GG.cart = {
    state: null,
    /* The base variant id for a line that has been swapped to its saving twin (else the id itself). */
    baseId: function (vid) { var m = swapMaps(); return Number(m.rev[String(vid)] || vid); },
    /* [base price per unit (pence), label] for a saving line, else null. */
    saving: function (vid) {
      var m = swapMaps(), b = m.rev[String(vid)];
      if (!b) return null;
      var e = m.S[b], L = window.GGSwapLabels || {};
      return [Number(e[1]), L[e[2]] || ''];
    },
    get: function () { return json('cart.js').then(function (c) { GG.cart.state = c; return c; }); },
    /* items: [{ id: variantId, quantity: 1, properties: {}, selling_plan: id }]
       Skips variants already in the cart (package add-ons and pairing rely on this). */
    add: function (items, opts) {
      opts = opts || {};
      return GG.cart.get().then(function (cart) {
        var inCart = {}; cart.items.forEach(function (i) { inCart[i.variant_id] = true; inCart[GG.cart.baseId(i.variant_id)] = true; });
        var fresh = items.filter(function (i) { return opts.allowDuplicates || !inCart[Number(i.id)]; });
        var plans = window.GGPlans || {};
        fresh.forEach(function (i) { if (!i.selling_plan && plans[String(i.id)]) i.selling_plan = plans[String(i.id)]; });
        var attrs = {}; if (GG.ref && cart.attributes.ref !== GG.ref) attrs.ref = GG.ref;
        if (GG.referrer && cart.attributes.referred_by !== GG.referrer) attrs.referred_by = GG.referrer;
        var p = Object.keys(attrs).length ? json('cart/update.js', { attributes: attrs }) : Promise.resolve();
        return p.then(function () { return fresh.length ? json('cart/add.js', { items: fresh }) : null; });
      }).then(function () { return GG.cart.refresh(opts.open !== false); });
    },
    change: function (key, quantity) {
      return json('cart/change.js', { id: key, quantity: quantity }).then(function () { return GG.cart.refresh(false); });
    },
    update: function (body) { return json('cart/update.js', body).then(function () { return GG.cart.refresh(false); }); },
    refresh: function (open) {
      return GG.cart.get().then(function (c) {
        var ops = swapping ? [] : swapOps(c);
        if (!ops.length) return c;
        swapping = true;
        return applySwap(ops).catch(function () {}).then(function () { swapping = false; return GG.cart.get(); });
      }).then(function (c) {
        document.dispatchEvent(new CustomEvent('gg:cart:changed', { detail: c }));
        if (open) document.dispatchEvent(new CustomEvent('gg:cart:open'));
        return c;
      });
    },
    open: function () { document.dispatchEvent(new CustomEvent('gg:cart:open')); }
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gg-cart-open]');
    if (b) { e.preventDefault(); GG.cart.open(); }
  });
  document.addEventListener('gg:cart:changed', function (e) {
    var n = e.detail.item_count;
    document.querySelectorAll('[data-gg-cart-count]').forEach(function (el) { el.textContent = n; });
  });

  /* ---------- Call us / WhatsApp switch (WhatsApp between 6pm and 6am UK time) ---------- */
  GG.contact = function () {
    var hour;
    try { hour = parseInt(new Intl.DateTimeFormat('en-GB', { hour: 'numeric', hour12: false, timeZone: 'Europe/London' }).format(new Date()), 10); }
    catch (e) { hour = new Date().getHours(); }
    var night = hour >= 18 || hour < 6;
    document.querySelectorAll('[data-gg-contact]').forEach(function (a) {
      var day = a.querySelector('[data-gg-contact-day]'), nightIcon = a.querySelector('[data-gg-contact-night]');
      var label = a.querySelector('[data-gg-contact-label]');
      if (night && cfg.whatsappHref) {
        a.href = cfg.whatsappHref; a.target = '_blank'; a.rel = 'noopener';
        if (label) label.textContent = cfg.whatsappLabel || 'WhatsApp';
        if (day) day.hidden = true; if (nightIcon) nightIcon.hidden = false;
      }
    });
  };

  /* ---------- Cookie consent (PECR): one banner, recorded through Shopify's Customer Privacy API ---------- */
  GG.consent = {
    banner: function () { return document.getElementById('gg-cookie-banner'); },
    show: function () { var b = GG.consent.banner(); if (b) { b.hidden = false; } },
    hide: function () { var b = GG.consent.banner(); if (b) b.hidden = true; },
    set: function (accepted) {
      var v = { analytics: accepted, marketing: accepted, preferences: accepted, sale_of_data: accepted };
      GG.setCookie('gg_consent', accepted ? 'all' : 'essential', 365); GG.consent.hide();
      try { if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) Shopify.customerPrivacy.setTrackingConsent(v, function () {}); } catch (e) {}
    },
    init: function () {
      var load = function () {
        var needs = true;
        if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.shouldShowBanner) needs = Shopify.customerPrivacy.shouldShowBanner();
        if (GG.getCookie('gg_consent')) needs = false;
        if (needs) GG.consent.show();
      };
      if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { load(); });
      } else { load(); }
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-gg-consent-accept]')) GG.consent.set(true);
        else if (e.target.closest('[data-gg-consent-reject]')) GG.consent.set(false);
        else if (e.target.closest('[data-gg-cookie-settings]')) { e.preventDefault(); GG.consent.show(); var b = GG.consent.banner(); if (b) { var f = b.querySelector('button'); if (f) f.focus(); } }
      });
    }
  };

  /* ---------- Ticker duplicate for seamless loop ---------- */
  GG.init = function (root) { GG.reveal(root); GG.fillDates(root); };

  document.addEventListener('DOMContentLoaded', function () {
    GG.init(document); GG.contact(); GG.consent.init(); GG.cart.refresh(false).catch(function () {});
  });
  document.addEventListener('shopify:section:load', function (e) { GG.init(e.target); GG.contact(); });
})();
